export default "__VITE_ASSET__C34JhNtH__"